import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../../hooks/useApi"
import { IRefreshTradingDataResponse } from "../types"

const useRefreshTradingData = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: IRefreshTradingDataResponse) => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()
  return useMutation(scientApi.trading.refreshTradingData, { onSuccess, onError })
}

export default useRefreshTradingData
